import { useMemo } from 'react';
import { useAuthState } from 'state';
import { User } from 'types';
import ApiService from './ApiService';

export class UserService extends ApiService {

    async getUsers(isInternal?: string): Promise<User[]> {
        const { data, status } = await this.get(`/api/users${isInternal ? "?isInternal=" + isInternal : ""}`);
        return this.IsSuccessStatusCode(status) ? data : [];
    }
    
    async getCurrentUser(): Promise<User> {
        const { data, status } = await this.get(`/api/users/current`)
        return this.IsSuccessStatusCode(status) ? data : null;
    }
}

export const useUserService = () => {
    const auth = useAuthState();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    return useMemo(() => new UserService(), [auth]);
};